const styles = theme => ({
  content: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    maxWidth: '800px',
    maxHeight: '600px',
    overflowY: 'auto',
  },
  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    /* Body/Body 2 */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 24px */,
  },
  title: {
    color: 'var(--Gray-Darker, #838D98)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  note: {
    color: 'var(--Gray-Darker, #838D98)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  badgeLeft: {
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #E3F3FF)',
  },
  badgeRight: {
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
  description: {
    color: '#4B5563',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  dividerContainer: {
    width: '100%',
  },
  divider: {
    height: '1px',
    background: '#E5E7EB',
  },
  educationalText: {
    color: '#4B5563',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%' /* 21px */,
    marginRight: '4px',
  },
  educationalContainer: {
    display: 'flex',
  },
  headerSelect: {
    color: 'var(--mcg-dark, #002E47)',
    /* Button/Large */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
  selectContainer: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--12, 12px)',
    alignSelf: 'stretch',
    borderRadius: '12px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
  badgeContainer: {
    display: 'flex',
    gap: '12px',
  },
  buttonContainer: {
    background: '#fff',
    bottom: '0',
    position: 'sticky',
    marginTop: '28px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2, 0),
  },
  textSection: {
    flex: 1,
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1),
  },

  stepperContainer: {
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  stepper: {
    backgroundColor: 'transparent',
    padding: theme.spacing(2, 0),
  },
  stepContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxHeight: '456px',
    width: '100%',
    margin: '0 auto',
    padding: '0 16px',
    boxSizing: 'border-box',

    '@media (max-width: 768px)': {
      height: '500px',
      maxWidth: '100%',
      padding: '0 12px',
      gap: '12px',
    },

    '@media (max-width: 480px)': {
      height: '400px',
      padding: '0 8px',
      gap: '8px',
    },
  },

  badgeTitle: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
  descriptionContainer: {
    width: '100%',
  },
  titleContainer: {
    width: '100%',
  },
  confirmationCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    gap: '16px',
    borderRadius: '12px',
    border: '2px solid #10B981',
    background: '#F0FDF4',
    width: '100%',
  },
  confirmationHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  confirmationContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  confirmationRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    '@media (min-width: 600px)': {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: '12px',
    },
  },
  confirmationChip: {
    height: '24px',
    fontSize: '12px',
    alignSelf: 'flex-start',
  },
  sourceTextInfo: {
    padding: '16px',
    borderRadius: '8px',
    background: '#F9FAFB',
    border: '1px solid #E5E7EB',
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    flexDirection: 'column',
    gap: '8px',
  },

  icon: {
    width: '20px',
    height: '20px',
  },
  row: {
    display: 'grid',
    gap: '4px',
  },
  box: {
    marginTop: '8px',
    display: 'grid',
    gap: '16px',
  },
  popover: {
    zIndex: '99999 !important',
  },
  pickerBg: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    width: 36,
    height: 36,
    background: '#f2f2f2',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  pickerSpan: {
    width: 24,
    height: 24,
    borderRadius: '10px',
    background: 'red',
  },
  boxIconButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: '1 0 0',
  },
  boxSourceButton: {
    display: 'flex',
    height: '100px',
    padding: '20px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
    cursor: 'pointer',
  },
})

export default styles
